import { render } from "./Testimonial6Content.vue?vue&type=template&id=2be04928&scoped=true&ts=true"
import script from "./Testimonial6Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial6Content.vue?vue&type=script&lang=ts"

import "./Testimonial6Content.vue?vue&type=style&index=0&id=2be04928&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be04928"]])

export default __exports__